// import third party
import { Box, Flex, Text } from '@chakra-ui/react';

// import local
import { useBundleStore } from '@pages/UploadMappingV2/hooks/state/useAddProductBundle';
import ModalConfirmTemplate from '../ui/ModalConfirmTemplate';

export default function ModalConfirmAddProduct({ isOpen, onClose, onSubmit }) {
    const { bundles, directBundles, isDirectEditing, isLoading } = useBundleStore();
    const activeBundles = isDirectEditing ? directBundles : bundles;
    const totalItems = activeBundles.reduce((sum, b) => sum + b.items.length, 0);

    return (
        <ModalConfirmTemplate
            isOpen={isOpen}
            onClose={onClose}
            isCentered
            isCenterBtn
            onSubmit={onSubmit}
            modalTitle={isDirectEditing ? 'Perbaharui Product' : 'Upload Satuan'}
            width="600px"
            btnTitleCancel="Batalkan"
            isHelperText
            isLoading={isLoading}
        >
            <Flex
                justifyContent={'center'}
                alignItems={'center'}
                flexDir={'column'}
                gap={'8px'}
                py={'16px'}
                textAlign={'center'}
            >
                <Box p={'16px'} borderRadius={'4px'} bgColor={'semantic.200'} mb={'18px'}>
                    <Text fontSize={'26px'} fontWeight={'bold'}>
                        {totalItems} Product
                    </Text>
                    <Text color={'neutral.600'}>{isDirectEditing ? 'Diperbaharui' : 'Terhubung'}</Text>
                </Box>
                <Text maxW={'500px'}>
                    Produk mapping akan menghubungkan kode produk paragon dengan kode produk di toko kamu.
                </Text>
            </Flex>
        </ModalConfirmTemplate>
    );
}
